import { Icon, IconProps, forwardRef } from '@bitrise/bitkit';
import { PROJECT_TYPE_ICON_MAP, ProjectType } from '@/models/ProjectType';

export type PlatformIconProps = {
  type?: ProjectType;
} & Omit<IconProps, 'name'>;

const PlatformIcon = forwardRef((props: PlatformIconProps, ref) => {
  const { type = 'other', ...rest } = props;
  return <Icon name={PROJECT_TYPE_ICON_MAP[type || 'other']} {...rest} ref={ref} />;
});

export default PlatformIcon;
